var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CSidebar',{staticStyle:{"background-color":"white !important","color":"black !important","font-size":"12px"},attrs:{"minimize":_vm.minimize,"unfoldable":"","show":_vm.show},on:{"update:show":(value) => _vm.$store.commit('set', ['sidebarShow', value])}},[_c('CRenderFunction',{attrs:{"flat":"","contentToRender":_vm.menu}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }